import { render } from "./PShop.vue?vue&type=template&id=0b42bcf0"
import script from "./PShop.vue?vue&type=script&lang=js"
export * from "./PShop.vue?vue&type=script&lang=js"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__